import { render, staticRenderFns } from "./Smartsvar.vue?vue&type=template&id=70b42876&"
import script from "./Smartsvar.vue?vue&type=script&lang=js&"
export * from "./Smartsvar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports